export const HamburgerIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 0 40 40">
    <g>
      <path fill="currentColor" d="M3.201,10.015V3.981h35.344v6.033H3.201z" />
      <path fill="currentColor" d="M3.201,23.994v-6.032h35.344v6.032H3.201z" />
      <path fill="currentColor" d="M3.201,37.977v-6.033h35.344v6.033H3.201z" />
    </g>
  </svg>
);

export const NotificationIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 -960 960 960" fill="currentColor">
    <path d="M160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160ZM480-80q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80Z" />
  </svg>
);

export const SearchIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 -960 960 960" fill="currentColor">
    <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
  </svg>
);

export const SettingsIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 -960 960 960" fill="currentColor">
    <path d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm112-260q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Z" />
  </svg>
);

export const HelpIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 -960 960 960" fill="currentColor">
    <path d="M478-240q21 0 35.5-14.5T528-290q0-21-14.5-35.5T478-340q-21 0-35.5 14.5T428-290q0 21 14.5 35.5T478-240Zm-36-154h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z" />
  </svg>
);

export const DescriptionIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 -960 960 960" fill="currentColor">
    <path d="M320-240h320v-80H320v80Zm0-160h320v-80H320v80ZM240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520h200L520-800v200Z" />
  </svg>
);

export const ForumIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 -960 960 960" fill="currentColor">
    <path d="M280-240q-17 0-28.5-11.5T240-280v-80h520v-360h80q17 0 28.5 11.5T880-680v600L720-240H280ZM80-280v-560q0-17 11.5-28.5T120-880h520q17 0 28.5 11.5T680-840v360q0 17-11.5 28.5T640-440H240L80-280Z" />
  </svg>
);

export const TimerIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={className} viewBox="0 -960 960 960" fill="currentColor">
    <path d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74 28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49 49-114.5 77.5T480-80Z" />
  </svg>
);

export const ShoutIcon = ({ className }: React.SVGProps<SVGSVGElement>) => (
  <svg className={`${className} -scale-y-100`} viewBox="0 0 960 960" fill="currentColor">
    <path d="M950.4 931.2c54.4-252.8 54.4-496 0-752-28.8 19.2-51.2 32-73.6 48-108.8 86.4-233.6 131.2-371.2 134.4-25.6 0-38.4 12.8-38.4 38.4 0 102.4 0 208 0 310.4 0 12.8 19.2 35.2 28.8 38.4 160 6.4 297.6 67.2 419.2 166.4 12.8 3.2 19.2 6.4 35.2 16zM256 355.2c-32 6.4-60.8 6.4-86.4 16-86.4 25.6-147.2 118.4-134.4 201.6 12.8 105.6 89.6 172.8 192 176 51.2 0 105.6 0 156.8 0 28.8 0 41.6-12.8 41.6-41.6 0-204.8 0-476.8 0-681.6 0-35.2-19.2-54.4-54.4-57.6-16 0-35.2 0-51.2 0-44.8 3.2-60.8 16-60.8 64 0 73.6 0 211.2 0 284.8 0 9.6-3.2 25.6-3.2 38.4z" />
  </svg>
);
